module.exports = __webpack_public_path__ + "static/media/Art_and_Music.4a3c30a8.md";